<template>
  <div class="participate-button-container">
    <div class="participate-btn-container" v-if="(!tournamentStarted && registrationStatus)"> <!-- (!tournamentStarted && registrationStatus)  -->
      <div class="participate-btn d-flex justify-content-center align-items-center px-4 mt-1" v-if="!isAuthenticated">
        <p class="m-0 label-participate text-white text-center text-uppercase w-100 py-1" data-toggle="modal" data-target="#loginModal"
                @click="participateAction(tournamentId)">
          {{$t('participate')}}
        </p>
      </div>
      <div class="participate-btn d-flex justify-content-center align-items-center mt-1"  v-else>
        <p  class="m-0 px-4 label-participate text-white text-center text-uppercase w-100 py-1" data-toggle="modal" data-target="#lgame-participation-pop-up" @click="participateAction(tournamentId)"
                v-if="(!isParticipant)">
          {{$t('participate')}}
        </p>
        <p class="m-0 px-2 label-participate label-cancel text-center text-white text-uppercase w-100 py-1" data-toggle="modal" data-target="#lgame-participation-pop-up"
                @click="cancelParticipateAction(tournamentId)" v-else>
          {{$t('cancelParticipate')}}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment/moment";
import { mapState, mapGetters } from 'vuex';

export default {
  props: ['tournamentId'],
  data(){
    return {
      participantsSize: 0,
      TYPE_PLAYER: 1,
      TYPE_TEAM: 2,
      isLoadingAction: false,
    }
  },
  computed:{
    ...mapState('subTournaments', {
      tournaments: state => state.tournaments,
      tournamentsLoaded: state => state.tournamentsLoaded,
      selectedTournament: state => state.selectedTournament,
      participationsByTeam: state => state.participationsByTeam,
    }),
    ...mapGetters('subTournaments', ['getTournament']),
    currentTournament(){
      /*return this.tournamentsLoaded
          ? this.getTournament(this.tournamentId, this.$route.name)
          : null;*/
      return this.tournamentsLoaded ? this.$store.getters["subTournaments/getTournament"](this.tournamentId, this.$route.name) : {};
    },
    isAuthenticated: {
      get() {
        return this.$store.state.currentUser.isAuthenticated;
      }
    },
    currentUser(){
      return this.$store.state.currentUser;
    },
    registrationStatus: { // true:  open, false: closed
      get() {
        if (this.tournamentsLoaded) {
          return this.currentTournament.settings.registration_status;
        }
        return false;
      }
    },
    registrationEnds: {
      get() {
        if (this.tournamentsLoaded) {
          moment.locale('fr');
          const dateTime = this.currentTournament.start_date + ' ' + this.currentTournament.start_time;
          return moment(dateTime, 'DD-MM-YYYY HH:mm').format('ddd Do, MMM  [à] hA');
        }
      }
    },
    isPastTournament: {
      get() {
        if (this.tournamentsLoaded) {
          const dateTime = this.currentTournament.end_date + ' ' + this.currentTournament.end_time;
          console.log(moment(dateTime, 'DD-MM-YYYY HH:mm'));
          return moment().isAfter(moment(dateTime, 'DD-MM-YYYY HH:mm'));
        }
      }
    },
    checkInStarted: {
      get() {
        if (this.tournamentsLoaded) {
          const startDateTime = this.currentTournament.start_date + ' ' + this.currentTournament.start_time;
          const checkInStartsIn = this.currentTournament.settings.check_in_starts;
          const checkinStartTime = moment(startDateTime, 'DD-MM-YYYY HH:mm').subtract(checkInStartsIn, 'minutes').toDate();
          return moment().isBefore(moment(startDateTime, 'DD-MM-YYYY HH:mm')) && moment().isAfter(moment(checkinStartTime));
        }
      }
    },
    tournamentStarted:{
      get() {
        if (this.tournamentsLoaded) {
          const startDateTime = this.currentTournament.start_date + ' ' + this.currentTournament.start_time;
          return moment().isSameOrAfter(moment(startDateTime, 'DD-MM-YYYY HH:mm'));
        }
        return true;
      }
    },
    participantType: {
      get() {
        if (this.tournamentsLoaded) {
          const size = this.currentTournament.settings.play_mode.size;
          return size > 1 ? this.TYPE_TEAM : this.TYPE_PLAYER;
        }
      }
    },
    tournamentSize: {
      get(){
        if (this.tournamentsLoaded) {
          return this.currentTournament.settings.size;
        }

      }
    },
    participantCount: {
      get() {
        if (this.tournamentsLoaded) {
          return this.participantType === this.TYPE_PLAYER ?
              this.currentTournament.participants_players.length :
              this.currentTournament.participants_teams.length;
        }
        return 0;
      }
    },
    isParticipant: {
      get() {
        if (this.tournamentsLoaded) {
          return this.$store.getters["subTournaments/isParticipantInTournament"](this.tournamentId);
        }
        return false;
      },
    },
    isParticipantCheckedIn: {
      get(){
        if (this.tournamentsLoaded) {
          return this.$store.state.subTournaments.tournaments[this.$route.name][Number(this.tournamentId)].isCheckedIn;
        }
        return false;
      },
    },
    hasCustomFields: {
      get() {
        if (this.tournamentsLoaded) {
          const customFields = this.currentTournament.settings.custom_fields;
          return customFields !== null && customFields.length > 0;
        }
        return false;
      }
    },
    teamParticipatedId: {
      get() {
        if (this.tournamentsLoaded) {
          return this.currentTournament.teamParticipatedId;
        }
        return null;
      }
    },
    isUserAuth: {
      get() {
          return this.$store.state.currentUser.isAuthenticated;
      }
    },
    tournamentsLoaded(){
      return this.$store.state.subTournaments.tournamentsLoaded;
    }
  },
  watch: {
    currentTournament: {
      handler(newTournament, oldTournament) {
        console.log('🎯 currentTournament changed:', newTournament)
        this.checkParticipation();
        this.$forceUpdate()
      },
      deep: true,
      immediate: true    // run once upon component creation
    },
    isUserAuth(newVal, oldVal) {
      if (oldVal === false && newVal === true && !this.isParticipant) {
        this.checkParticipation();
      }
    }
  },
  methods: {
    participateAction(tournamentId) {
      this.$store.dispatch('subTournaments/setSelectedTournament', {
        tournamentId: tournamentId,
        gameName: this.$route.name,
      }).then(() => {
        console.log("participate btn clicked ...")
        // participate current auth user
        if (this.isAuthenticated) {
          this.isLoadingAction = true;
          console.log("participate action currentUser: ", this.currentUser)
          const payload = {
            playerId: this.currentUser.user.player.id,
            gameId: this.selectedTournament.game.id,
            tournamentId: tournamentId,
            playModeSize: this.selectedTournament.settings.play_mode.size
          }
          if (this.participantType === this.TYPE_TEAM) {
            this.$store.dispatch('currentTournament/getSingleCurrentPlayerTeams', {
              ...payload
            })
            this.$emit('init-pop-up', {
              type: 'teams',
              title: "Choose a team",
              message: "Choose one of your teams to take part in this tournament:",
              withOptions: false,
              action:  {
                action:'subTournaments/registerTeamIn',
                payload:{
                  tournamentId: tournamentId,
                  gameId: this.currentTournament.game.id,
                  playModeSize: this.currentTournament.settings.play_mode.size,
                  gameName: this.$route.name
                }
              }
            });
          }
          if (this.participantType === this.TYPE_PLAYER) {
            if (this.hasCustomFields) {
              this.$emit('init-pop-up', {
                type: 'custom',
                withOptions: true,
                title: "Registration form",
                message: 'Please fill in the following fields to take part in the tournament',
                options: {
                  mainAction: 'Participate',
                  secondAction: 'Cancel'
                },
                action: {
                  action: 'subTournaments/registerParticipantIn',
                  payload: {
                    tournamentId: tournamentId,
                    gameId: this.currentTournament.game.id,
                    playModeSize: this.currentTournament.settings.play_mode.size,
                    gameName: this.$route.name,
                    playerId: this.currentUser.user.player.id,
                  }
                }
              });
            } else {
              this.$store.dispatch('subTournaments/registerParticipantIn', {
                playerId: this.currentUser.user.player.id,
                tournamentId: tournamentId,
                gameName: this.$route.name,
              })
                  .then(() => {
                    this.$store.dispatch('currentTournament/triggerLoading', false);
                  });
            }
          }
        } else {
          this.$root.$emit('show-login', {
            action:'check_participation',
            payload:{
              tournamentId: tournamentId,
              gameId: this.currentTournament.game.id,
              playModeSize: this.currentTournament.settings.play_mode.size,
              gameName: this.$route.name
            }
          });
        }
      });

      this.isLoadingAction = false;
    },
    async cancelParticipateAction() {
      await this.$store.dispatch('subTournaments/setSelectedTournament', {
        tournamentId: this.tournamentId,
        gameName: this.$route.name,
      });
      this.$store.dispatch('currentTournament/triggerLoading', true);
      if (this.participantType === this.TYPE_PLAYER) {
        console.log('cancelling player participation')
        this.$emit('init-pop-up', {
          type: 'warning',
          withOptions: true,
          title: 'Attention !',
          message: 'Are you sure you want to cancel your participation?',
          action:{
            action: 'subTournaments/cancelParticipation',
            payload:{
              tournamentId: this.tournamentId,
              playerId: this.currentUser.user.player.id,
              gameName:this.$route.name,
            }
          }
        });
      }
      if (this.participantType === this.TYPE_TEAM) {
        this.$emit('init-pop-up', {
          type: 'warning',
          withOptions: true,
          title: 'Attention !',
          message: 'Are you sure you want to cancel your participation?',
          action:{
            action: 'subTournaments/cancelTeamParticipation',
            payload:{
              tournamentId: this.tournamentId,
              playerId: this.currentUser.user.player.id,
              playMode: this.currentTournament.settings.play_mode.size,
              gameName:this.$route.name,
              teamId: this.participationsByTeam[this.tournamentId],
            }
          }
        });
        console.log('cancelling team participation')
        /*this.$store.dispatch('currentTournament/cancelTeamParticipation')
            .then(() => {
                this.isLoadingAction = false;
            });*/
      }

    },
    checkPlayerIn() {
      this.$store.dispatch('currentTournament/checkPlayerIn');
    },
    checkParticipantIn() {
      this.$store.dispatch('currentTournament/triggerLoading', true);
      if (this.participantType === this.TYPE_TEAM) {
        this.$store.dispatch('currentTournament/checkTeamIn', {
          teamId: this.teamParticipatedId,
          checkinValue: true,
          gameName:this.$route.name,
        }).then(() => {
          this.$store.dispatch('currentTournament/triggerLoading', false);
        });
      }
      if (this.participantType === this.TYPE_PLAYER) {
        this.$store.dispatch('currentTournament/checkPlayerIn', {
          checkinValue: true,
          gameName:this.$route.name,
        })
            .then(() => {
              this.$store.dispatch('currentTournament/triggerLoading', false);
            });
      }
    },
    cancelCheckIn() {
      //only team case done
      this.$store.dispatch('currentTournament/triggerLoading', true);
      if (this.participantType === this.TYPE_PLAYER) {
        this.$emit('init-pop-up', {
          type: 'warning',
          withOptions: true,
          title: 'Attention !',
          message: 'Are you sure you want to cancel your checkin?',
          action: {
            action: 'currentTournament/checkPlayerIn',
            payload:{
              playerId: this.currentUser.user.player.id,
              tournamentId: this.tournamentId,
              checkinValue: false,
              gameName:this.$route.name,
            }
          },
        })
      }
      if (this.participantType === this.TYPE_TEAM) {
        this.$emit('init-pop-up', {
          type: 'warning',
          withOptions: true,
          title: 'Attention !',
          message: 'Are you sure you want to cancel your checkin ?',
          action:{
            action:  'currentTournament/checkTeamIn',
            payload: {
              teamId: this.teamParticipatedId,
              checkinValue: false,
              playerId: this.currentUser.user.player.id,
              tournamentId: this.tournamentId,
              gameName:this.$route.name,
            }
          }
        });
      }
    },
    viewBracket() {
      this.$emit('view-bracket');
    },
    /*async getTournament(tournamentId){
      await this.$store.dispatch('currentTournament/getSingleTournament', tournamentId).then(res => {
        this.currentTournament = Object.assign({}, res.data.data);
        console.log("tournament data: (received) ", res.data.data)
        console.log("currentTournament data: ", this.currentTournament);
        this.checkParticipation();
      })
    },*/
    checkParticipation(){
      console.log("checking participation ...")
      if (this.isAuthenticated && this.tournamentsLoaded){
        console.log("check playerId ", this.currentUser.user.player.id)
        this.$store.dispatch('subTournaments/checkParticipation', {
          gameId: this.currentTournament.game.id,
          tournamentId: this.currentTournament.id,
          playerId: this.currentUser.user.player.id,
          playModeSize: this.currentTournament.settings.play_mode.size,
          gameName: this.$route.name
        })/*.then(res => {
          console.log("participation data: (received) ", res)
          if (res.data.success){
            console.log("participation data: (received) ", res.data.isParticipant, res.data.isCheckedIn)
            this.isParticipant = res.data.isParticipant;
            this.isCheckedIn = res.data.isCheckedIn;
          }
        })*/
      }
    }
  },
  mounted(){
    //await this.getTournament(this.tournamentId);
    //this.checkParticipation();
  }
}
</script>
<style scoped>
.participate-btn {
  background-color: var(--main-color);
  outline: none;
  border: none;
  color: white;
  font-family: "sqwaredsemi_bold";
  padding-top: 2px;
  padding-bottom: 2px;
  text-transform: uppercase;
  clip-path: polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px);
  cursor: pointer;
  height: 28px;
}
.participate-btn:hover{
  transform: scale(1.005);
  background-color: #ff3f1a;
}
.label-participate{
  font-size: 12px;
}
</style>